import { round } from 'lodash';
import {
  CoreFeeType,
  FeeCalculationBasis,
  FeeType,
  FeeChargingFrequency,
  FeeAccounting,
} from 'further-types/investment';
import { FeeTemplateFormData } from '..';

const calculateGrossFee = (coreFees, vat, netFee, index) => {
  if (vat) {
    coreFees[index].grossFee = round(netFee * 1.2, 10);
  } else {
    coreFees[index].grossFee = +netFee || 0;
  }
};

const recalculateCoreFee = (
  coreFees: FeeTemplateFormData['coreFees'],
  name: string,
  value: string,
  index: number,
) => {
  if (name === 'vat') {
    calculateGrossFee(coreFees, value, coreFees[index].netFee, index);
  } else if (name === 'netFee') {
    calculateGrossFee(coreFees, coreFees[index].vat, value, index);
    coreFees[index].netFee = value ? +value : null;
    return coreFees;
  }
  if (name === 'displayFeeType') {
    let isInitial = false;

    if (
      CoreFeeType.InitialFixed === value ||
      CoreFeeType.InitialPercentage === value
    ) {
      isInitial = true;
    }

    coreFees[index].feeType = isInitial ? FeeType.Initial : FeeType.Recurring;
    if (isInitial) {
      coreFees[index].chargingFrequency = undefined;
      coreFees[index].startingPeriod = null;
      coreFees[index].finishingPeriod = null;
      coreFees[index].feeCalculationBasis = null;
      coreFees[index].minimumFeePercentage = null;
    } else {
      coreFees[index].chargingFrequency =
        coreFees[index]?.chargingFrequency ?? FeeChargingFrequency.Monthly;
      coreFees[index].startingPeriod = coreFees[index]?.startingPeriod ?? null;
      coreFees[index].finishingPeriod =
        coreFees[index]?.finishingPeriod ?? null;
      coreFees[index].minimumFeePercentage =
        CoreFeeType.RecurringPercentage === value ? 0 : null;
      coreFees[index].feeCalculationBasis =
        CoreFeeType.RecurringPercentage === value
          ? FeeCalculationBasis.PercentageOfTotalCommitment
          : null;
    }
  }

  if (name === 'feeCalculationBasis') {
    if (value === FeeCalculationBasis.PercentageOfUnrealisedAssetCost) {
      coreFees[index].feeAccounting = FeeAccounting.Accrued;
    } else {
      coreFees[index].minimumFeePercentage = 0;
    }
  }

  coreFees[index][name] = value;
  return coreFees;
};

export default recalculateCoreFee;
